export default __webpack_public_path__ + "static/media/tabebuya-1.ff0bc776.JPG";